module.exports = __webpack_public_path__ + "img/am.400cb965.svg";